import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-product-lock',
  templateUrl: './icon-product-lock.component.html',
  styleUrls: ['./icon-product-lock.component.scss']
})
export class IconProductLockComponent implements OnInit {

  @Input() cssClass = 'icon--24';

  constructor() { }

  ngOnInit(): void {
  }

}
